import React from 'react'
import { Link } from 'react-router-dom'

const FooterInner = () => {
  return (
    <div id="footer">
    <Link to="/carter/feedback" className="first">Feedback</Link>
    <Link to="/carter/privacypolicy">Privacy Policy</Link>
    <Link to="/carter/terms">Terms of Use</Link>
    <span className="copyright">Open Play Tennis Copyright <span className="copyRtText"> &copy; </span> 2025. All rights reserved</span>
 </div>
  )
}

export default FooterInner